import React, { useState, useEffect } from "react";
import { useStore } from "../../contexts/store-provider";

const LanguageSlider = () => {
  const { preferencesStore } = useStore();
  const [lang, setLang] = useState(preferencesStore.getLanguage);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const changeLanguage = (newLang:any) => {
    setLang(newLang);
    preferencesStore.changeLanguage(newLang);
    setDropdownOpen(false); // Close dropdown after selection
    const body = document.body;
    body.classList.forEach(cls => {
      if (cls.startsWith("lang-")) {
        body.classList.remove(cls);
      }
    });
    body.classList.add(`lang-${newLang}`);
  };

  // Desktop: Toggle switch
  if (windowWidth > 768) {
    return (
      <div className="text-center">
        <div className="language-toggle">
          <span className={lang === "jp" ? "active" : ""}>JP</span>
          <label className="switch mx-2">
            <input
              type="checkbox"
              checked={lang === "en"}
              onChange={() =>
                changeLanguage(lang === "en" ? "jp" : "en")
              }
            />
            <span className="slider round"></span>
          </label>
          <span className={lang === "en" ? "active" : ""}>EN</span>
        </div>
      </div>
    );
  }

  // Mobile: Bootstrap dropdown using Bootstrap globe icon
  return (
    <div className="text-center">
      <div className="dropdown">
        <button
          className="btn btn-primary dropdown-toggle"
          type="button"
           data-bs-toggle="dropdown" 
        >
          <i className="bi bi-globe"></i>
        </button>
        <ul
          className={`dropdown-menu dropdown-menu-end`}
        >
          <li>
            <button
              className={`dropdown-item${lang === "en" ? " active" : ""}`}
              onClick={() => changeLanguage("en")}
              type="button"
            >
              English
            </button>
          </li>
          <li>
            <button
              className={`dropdown-item${lang === "jp" ? " active" : ""}`}
              onClick={() => changeLanguage("jp")}
              type="button"
            >
              日本語
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default LanguageSlider;
